import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneNumber' })
export class PhoneNumberPipe implements PipeTransform {
  transform(value, args) {
    if (value == null) {
      return value;
    }

    let parsedValue: string = value.toString();

    // remove any potential format
    parsedValue = parsedValue.replace(/\+/g, '');
    parsedValue = parsedValue.replace(/\(/g, '');
    parsedValue = parsedValue.replace(/\)/g, '');
    parsedValue = parsedValue.replace(/-/g, '');
    parsedValue = parsedValue.replace(/ /g, '');

    // remove country code if present
    if (parsedValue.length > 10 && parsedValue.substring(0, 1) === '1') {
      parsedValue = parsedValue.substring(1);
    }

    return (
      parsedValue.substring(0, 3) +
      '-' +
      parsedValue.substring(3, 6) +
      '-' +
      parsedValue.substring(6)
    );
  }
}
